import { render, staticRenderFns } from "./RadarDetail.vue?vue&type=template&id=0d1661a4&scoped=true"
import script from "./RadarDetail.vue?vue&type=script&lang=js"
export * from "./RadarDetail.vue?vue&type=script&lang=js"
import style0 from "./RadarDetail.vue?vue&type=style&index=0&id=0d1661a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1661a4",
  null
  
)

export default component.exports